import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class AuthService {
  constructor() {
    this.token = localStorage.getItem('session_token');
    this.user = JSON.parse(localStorage.getItem('user_data') || 'null');
    
    // Set up axios interceptor
    if (this.token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
    }
  }

  // Google OAuth (placeholder for future implementation)
  initiateGoogleLogin() {
    const currentUrl = window.location.origin;
    const redirectUrl = `${currentUrl}/auth/callback`;
    // TODO: Replace with proper OAuth provider when ready
    window.location.href = `https://accounts.google.com/oauth/authorize?redirect_uri=${encodeURIComponent(redirectUrl)}`;
  }

  async handleGoogleCallback(sessionId) {
    try {
      const response = await axios.post(`${API}/auth/session`, {}, {
        headers: { 'X-Session-ID': sessionId }
      });
      
      this.setSession(response.data.session_token, response.data.user);
      return { success: true, user: response.data.user };
    } catch (error) {
      console.error('Google authentication failed:', error);
      return { success: false, error: error.response?.data?.detail || 'Authentication failed' };
    }
  }

  // Phone Authentication
  async sendPhoneVerification(phoneNumber) {
    try {
      const response = await axios.post(`${API}/auth/phone/send-code`, {
        phone_number: phoneNumber
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to send verification code:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to send code' };
    }
  }

  async verifyPhoneCode(phoneNumber, code) {
    try {
      const response = await axios.post(`${API}/auth/phone/verify-code`, {
        phone_number: phoneNumber,
        verification_code: code
      });
      
      this.setSession(response.data.session_token, response.data.user);
      return { success: true, user: response.data.user };
    } catch (error) {
      console.error('Phone verification failed:', error);
      return { success: false, error: error.response?.data?.detail || 'Verification failed' };
    }
  }

  setSession(token, user) {
    this.token = token;
    this.user = user;
    localStorage.setItem('session_token', token);
    localStorage.setItem('user_data', JSON.stringify(user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  logout() {
    this.token = null;
    this.user = null;
    localStorage.removeItem('session_token');
    localStorage.removeItem('user_data');
    delete axios.defaults.headers.common['Authorization'];
  }

  isAuthenticated() {
    return !!this.token && !!this.user;
  }

  getUser() {
    return this.user;
  }

  getToken() {
    return this.token;
  }
}

export default new AuthService();